// Version : 0.0.2
// Author : DINESH
// MODFIED DATA : 08-08-2025

import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import productActionTypes from './product.types';
import {
	addProductDetailsFailure,
	addProductDetailsResponseChanged,
	addProductDetailsSuccess,
	deleteProductDetailsFailure,
	deleteProductDetailsResponseChanged,
	deleteProductDetailsSuccess,
	fetchCustomProductDetailsFailure,
	fetchCustomProductDetailsResponseChanged,
	fetchCustomProductDetailsSuccess,
	fetchFilterProductListFailure,
	fetchFilterProductListResponseChanged,
	fetchFilterProductListSuccess,
	fetchProductDetailsFailure,
	fetchProductDetailsResponseChanged,
	fetchProductDetailsSuccess,
	getAllInstrumnetListFailure,
	getAllInstrumnetListResponseChanged,
	getAllInstrumnetListSuccess,
	getMasterAccountListFailure,
	getMasterAccountListResponseChanged,
	getMasterAccountListSuccess,
	getProductDetailsListFailure,
	getProductDetailsListResponseChanged,
	getProductDetailsListSuccess,
	getProductListFailure,
	getProductListResponseChanged,
	getProductListSuccess,
	updateProductDetailsFailure,
	updateProductDetailsResponseChanged,
	updateProductDetailsSuccess,
} from './product.action';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	customProductDetailsFetch,
	filterProductListGet,
	getAllInstrumentList,
	getMasterAccountList,
	productDetailsAdd,
	productDetailsDelete,
	productDetailsFetch,
	productDetailsUpdate,
	productListGet,
} from './product.services';

/** *********************  START ADD PRODUCT DETAILS  ******************** */
export function* createProduct({ payload }: any) {
	try {
		const key = 'AddProductDetailKey';
		const loanschedulelistJson = JSON.stringify(payload.loanschedulelist).replace(/"/g, "'");
		const getGoldInterestListJson = JSON.stringify(payload.getGoldInterestListArr).replace(
			/"/g,
			"'",
		);
		const {
			databaseName,
			companyID,
			productName,
			noOfHolidays,
			productAmount,
			productROI,
			numberOfInstalment,
			amountOutsanding,
			minProductAmount,
			maxProductAmount,
			minNumberOfInstalment,
			maxNumberOfInstalment,
			minProductInterest,
			maxProductInterest,
			principalType,
			interestPayType,
			insuranceCompany,
			whichWeek,
			whichDay,
			isPayAsYouGo,
			isPercentagePenalty,
			isDayWisePenalty,
			dayPenalty,
			isAdjustInterestBasedOnDiffDays,
			isRoundOffToUpperValue,
			isProcessingFeeAutoDetect,
			effectiveDate,
			inActiveDate,
			isPreCloseCharge,
			preCloseChargePercentage,
			needDifferentialPayout,
			isCollectInterestOnDisbusement,
			isIncludeSaturday,
			isIncludeSunday,
			productInstallmentType,
			isCorporateProduct,
			percentageOnSellingPrice,
			minimumInterestDays,
			ordinaryDays,
			ordinaryAmount,
			registerDays,
			registerAmount,
			auctionDays,
			auctionAmount,
			productDescription,
			memberAmount,
			interestAmount,
			interestPercentage,
			noOfYear,
			installmentMethod,
			productInterestType,
			holidayType,
			userID,
			uniqueProductID,
			docCharges,
			processingFee,
			processingFeePercentage,
			cgst,
			cgstPercentage,
			igst,
			igstPercentage,
			sgst,
			sgstPercentage,
			productType,
			isPenalty,
			penaltyPercentage,
			verificationFee,
			hpFee,
			insuranceFee,
			insuranceFeePercentage,
			noOfDaysToStartDisbursement,
			isFirstWeekMonthly,
			isInstallmentBasedCollection,
			assetType,
			noOfDueInterval,
			isSameDateAsDue,
			intersetBasedOnStartDate,
			isFixedEMI,
			fixedEMIAmount,
			isBrokenPeriod,
			brokenPeriodDays,
			variedInterest,
			getGoldInterestListArr,
			principalAmountLedger,
			interestAmountLedger,
			loanAmountLedger,
			penaltyAmountLedger,
			bmAdvanceAmountLedger,
			writeOfftAmountLedger,
			interestWriteOffAmountLedger,
			interestAccuralLedger,
			disbursementType,
			chequeToBeCollected,
			insuranceProductLedger,
			noOfCheque,
			memberSettlement,
			memberAmountLedger,
			documentChargesLedger,
			processingFeeLedger,
			igstAmountLedger,
			cgstAmountLedger,
			sgstAmountLedger,
			verificationFeeLedger,
			hpInsuranceProductLedger,
			userAccessBranchID,
			userName,
			productTypeLoan,
			roadTax,
			staffIncentiveFees,
			dealerBrokerageFees,
			officeDocCharge,
			isAutoLoanProduct,
			isGoldProduct,
			isRangeProduct,
			fixedInterestPercentage,
			isThriftNeededOne,
			thriftIdOne,
			isThriftNeededTwo,
			thriftIdTwo,
		} = payload;

		const jsonData = {
			IsAutoLoanProduct: isAutoLoanProduct ? 1 : 0,
			IsGoldProduct: isGoldProduct ? 1 : 0,
			IsRangeProduct: isRangeProduct ? 1 : 0,
			RoadTax: roadTax,
			staffIncentiveFees: staffIncentiveFees,
			productTypeLoan: productTypeLoan,
			DealerBrokerageFees: dealerBrokerageFees,
			OfficeDocCharge: officeDocCharge,
			DatabaseName: databaseName,
			CompanyID: companyID,
			ProductName: productName,
			NoOfHolidays: noOfHolidays,
			ProductAmount: productAmount,
			ProductROI: productROI,
			NumberOfInstalment: numberOfInstalment,
			AmountOutsanding: amountOutsanding,
			minProductAmount: payload.minProductAmount ?? minProductAmount ?? 0,
			MinProductAmount: payload.minProductAmount ?? minProductAmount ?? 0,
			maxProductAmount: payload.maxProductAmount ?? maxProductAmount ?? 0,
			MaxProductAmount: payload.maxProductAmount ?? maxProductAmount ?? 0,
			minNumberOfInstalment: minNumberOfInstalment,
			maxNumberOfInstalment: maxNumberOfInstalment,
			minProductInterest: minProductInterest,
			maxProductInterest: maxProductInterest,
			PrincipalType: principalType,
			InterestPayType: interestPayType,
			InsuranceCompany: insuranceCompany,
			WhichWeek: whichWeek,
			WhichDay: whichDay,
			IsPayAsYouGo: isPayAsYouGo ? 1 : 0,
			IsPercentagePenalty: isPercentagePenalty ? 1 : 0,
			IsDaywisePenalty: isDayWisePenalty ? 1 : 0,
			DayPenalty: dayPenalty,
			goldProductFixedInterest: fixedInterestPercentage,
			IsAdjustInterestBasedOnDiffDays: isAdjustInterestBasedOnDiffDays ? 1 : 0,
			IsAdjustToUpperRoundOffValue: isRoundOffToUpperValue ? 1 : 0,
			IsProcessingFeeAutoDetect: isProcessingFeeAutoDetect ? 1 : 0,
			EffectiveDate: effectiveDate,
			InActiveDate: inActiveDate,
			IsPreCloseCharge: isPreCloseCharge ? 1 : 0,
			preClosePercentage: preCloseChargePercentage,
			NeedDifferentialPayout: needDifferentialPayout ? 1 : 0,
			IsCollectInterestOnDisbusement: isCollectInterestOnDisbusement ? 1 : 0,
			IncludeSaturday: isIncludeSaturday ? 1 : 0,
			IncludeSunday: isIncludeSunday ? 1 : 0,
			InstalmentType: productInstallmentType,
			IsCorporateProduct: isCorporateProduct ? 1 : 0,
			PercentageOnSellingPrice: percentageOnSellingPrice,
			GoldMinimumInterestDays: minimumInterestDays,
			ordinaryDate: ordinaryDays,
			ordinaryAmount: ordinaryAmount,
			registerDate: registerDays,
			registerAmount: registerAmount,
			auctionDate: auctionDays,
			auctionAmount: auctionAmount,
			ProductDescription: productDescription,
			MemberAmount: memberAmount,
			ProductPrincipal: interestAmount,
			ProductInterest: interestPercentage,
			NoOfYears: noOfYear,
			InstallmentMethod: installmentMethod,
			InstallmentReturnType: productInterestType,
			HolidayType: holidayType,
			ProductCreatedBy: userID,
			UniqueProductID: uniqueProductID,
			DocumentCharges: docCharges,
			ProcessingFees: processingFee,
			ProcessingFeesPercentage: processingFeePercentage,
			CGST: cgst,
			CGSTPercentage: cgstPercentage,
			IGST: igst,
			IGSTPercentage: igstPercentage,
			SGST: sgst,
			SGSTPercentage: sgstPercentage,
			ProductType: productType,
			IsPenalty: isPenalty ? 1 : 0,
			PenaltyPercentage: penaltyPercentage,
			verificationFee: verificationFee,
			HPFee: hpFee,
			InsurenseFee: insuranceFee,
			InsurenseFeePercentage: insuranceFeePercentage,
			Noofstartday: noOfDaysToStartDisbursement,
			IsFirstWeekMonthly: isFirstWeekMonthly ? 1 : 0,
			IsInstalmentBasedCollection: isInstallmentBasedCollection ? 1 : 0,
			AssetType: assetType,
			NoofDueInterval: noOfDueInterval,
			IsSameDueDate: isSameDateAsDue ? 1 : 0,
			IsInterestBasedOnStartDate: intersetBasedOnStartDate ? 1 : 0,
			IsFixedEMI: isFixedEMI ? 1 : 0,
			FixedEMIAmount: fixedEMIAmount,
			IsBrokenPeriodNeeded: isBrokenPeriod ? 1 : 0,
			BrokenPeriodDays: brokenPeriodDays,
			goldProductInterestArr: getGoldInterestListJson,
			interestType: variedInterest && getGoldInterestListArr.length > 0 ? 1 : 0,
			PrincipalAmountLedger: principalAmountLedger,
			InterestAmountLedger: interestAmountLedger,
			LoanAmountLedger: loanAmountLedger,
			PenaltyAmountLedger: penaltyAmountLedger,
			BMAdvanceAmountLedger: bmAdvanceAmountLedger,
			WriteOffLedger: writeOfftAmountLedger,
			InterestWriteOffLedger: interestWriteOffAmountLedger,
			InterestAccuralLedger: interestAccuralLedger,
			DisbursementType: disbursementType,
			ChequeToBeCollected: chequeToBeCollected,
			InsuranceProductLedger: insuranceProductLedger,
			NoOfCheque: noOfCheque,
			Membersettlement: memberSettlement,
			MemberAmountLedger: memberAmountLedger,
			DocumentChargesLedger: documentChargesLedger,
			ProcessingFeeLedger: processingFeeLedger,
			IGSTAmountLedger: igstAmountLedger,
			CGSTAmountLedger: cgstAmountLedger,
			SGSTAmountLedger: sgstAmountLedger,
			VerificationFeeLedger: verificationFeeLedger,
			HPInsuranceProductLedger: hpInsuranceProductLedger,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
			LoanDataforDiminishing: loanschedulelistJson,
			ProductTypeLoan: productTypeLoan,
			FixedInterestPercentage: fixedInterestPercentage,
			isThriftNeededOne: isThriftNeededOne,
			thriftIdOne: thriftIdOne,
			isThriftNeededTwo: isThriftNeededTwo,
			thriftIdTwo: thriftIdTwo,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(productDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addProductDetailsFailure(responseData.data));
		} else {
			yield put(addProductDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addProductDetailsFailure(error));
	}
}

export function* resetAddProductResponse() {
	yield put(addProductDetailsResponseChanged());
}

export function* onCreateProductDetails() {
	yield takeLatest(productActionTypes.ADD_PRODUCT_DETAILS_START, createProduct);
}

export function* onCreateProductResponseReset() {
	yield takeLatest(
		productActionTypes.ADD_PRODUCT_DETAILS_RESPONSE_RESET,
		resetAddProductResponse,
	);
}
/** *********************  END ADD PRODUCT DETAILS ******************** */

/** *********************  START UPDATE PRODUCT DETAILS  ******************** */
export function* productUpdate({ payload }: any) {
	try {
		const key = 'UpdateProductDetailsKey';
		let loanschedulelistJson = '';

		if (payload.loanschedulelist != undefined) {
			loanschedulelistJson = JSON.stringify(payload.loanschedulelist).replace(/"/g, "'");
		}
		let getGoldInterestListJson = '';

		if (payload.getGoldInterestListArr != undefined) {
			getGoldInterestListJson = JSON.stringify(payload.getGoldInterestListArr).replace(
				/"/g,
				"'",
			);
		}
		const {
			databaseName,
			companyID,
			productID,
			productName,
			noOfHolidays,
			productAmount,
			productROI,
			numberOfInstalment,
			amountOutsanding,
			minProductAmount,
			maxProductAmount,
			minNumberOfInstalment,
			maxNumberOfInstalment,
			minProductInterest,
			maxProductInterest,
			principalType,
			interestPayType,
			insuranceCompany,
			whichWeek,
			whichDay,
			isPayAsYouGo,
			isPercentagePenalty,
			isDayWisePenalty,
			dayPenalty,
			isAdjustInterestBasedOnDiffDays,
			isRoundOffToUpperValue,
			isProcessingFeeAutoDetect,
			effectiveDate,
			inActiveDate,
			isPreCloseCharge,
			preCloseChargePercentage,
			needDifferentialPayout,
			isCollectInterestOnDisbusement,
			isIncludeSaturday,
			isIncludeSunday,
			productInstallmentType,
			isCorporateProduct,
			percentageOnSellingPrice,
			minimumInterestDays,
			ordinaryDays,
			ordinaryAmount,
			registerDays,
			registerAmount,
			auctionDays,
			auctionAmount,
			productDescription,
			memberAmount,
			interestAmount,
			interestPercentage,
			noOfYear,
			installmentMethod,
			productInterestType,
			holidayType,
			userID,
			uniqueProductID,
			docCharges,
			processingFee,
			processingFeePercentage,
			cgst,
			cgstPercentage,
			igst,
			igstPercentage,
			sgst,
			sgstPercentage,
			productType,
			isPenalty,
			penaltyPercentage,
			verificationFee,
			hpFee,
			insuranceFee,
			insuranceFeePercentage,
			noOfDaysToStartDisbursement,
			isFirstWeekMonthly,
			isInstallmentBasedCollection,
			assetType,
			noOfDueInterval,
			isSameDateAsDue,
			intersetBasedOnStartDate,
			isFixedEMI,
			fixedEMIAmount,
			brokenPeriodDays,
			getGoldInterestListArr,
			principalAmountLedger,
			interestAmountLedger,
			loanAmountLedger,
			penaltyAmountLedger,
			bmAdvanceAmountLedger,
			writeOfftAmountLedger,
			interestWriteOffAmountLedger,
			interestAccuralLedger,
			disbursementType,
			chequeToBeCollected,
			insuranceProductLedger,
			noOfCheque,
			memberSettlement,
			memberAmountLedger,
			documentChargesLedger,
			processingFeeLedger,
			igstAmountLedger,
			cgstAmountLedger,
			sgstAmountLedger,
			verificationFeeLedger,
			hpInsuranceProductLedger,
			userAccessBranchID,
			userName,
			productTypeLoan,
			variedInterest,
			isAutoLoanProduct,
			isGoldProduct,
			isRangeProduct,
			isBrokenPeriod,
			roadTax,
			staffIncentiveFees,
			dealerBrokerageFees,
			officeDocCharge,
			fixedInterestPercentage,
			isThriftNeededOne,
			thriftIdOne,
			isThriftNeededTwo,
			thriftIdTwo,
		} = payload;

		const jsonData = {
			isThriftNeededOne,
			thriftIdOne,
			isThriftNeededTwo,
			thriftIdTwo,
			RoadTax: roadTax,
			staffIncentiveFees: staffIncentiveFees,
			productTypeLoan: productTypeLoan,
			DealerBrokerageFees: dealerBrokerageFees,
			OfficeDocCharge: officeDocCharge,
			IsBrokenPeriodNeeded: isBrokenPeriod ? 1 : 0,
			BrokenPeriodDays: brokenPeriodDays,
			IsAutoLoanProduct: isAutoLoanProduct ? 1 : 0,
			IsGoldProduct: isGoldProduct ? 1 : 0,
			IsRangeProduct: isRangeProduct ? 1 : 0,
			DatabaseName: databaseName,
			CompanyID: companyID,
			ProductID: productID,
			ProductName: productName,
			NoOfHolidays: noOfHolidays,
			ProductAmount: productAmount,
			ProductROI: productROI,
			NumberOfInstalment: numberOfInstalment,
			AmountOutsanding: amountOutsanding,
			minProductAmount: payload.minProductAmount ?? minProductAmount ?? 0,
			MinProductAmount: payload.minProductAmount ?? minProductAmount ?? 0,
			maxProductAmount: payload.maxProductAmount ?? maxProductAmount ?? 0,
			MaxProductAmount: payload.maxProductAmount ?? maxProductAmount ?? 0,
			minNumberOfInstalment: minNumberOfInstalment,
			maxNumberOfInstalment: maxNumberOfInstalment,
			minProductInterest: minProductInterest,
			maxProductInterest: maxProductInterest,
			PrincipalType: principalType,
			InterestPayType: interestPayType,
			InsuranceCompany: insuranceCompany,
			WhichWeek: whichWeek,
			WhichDay: whichDay,
			IsPayAsYouGo: isPayAsYouGo ? 1 : 0,
			IsPercentagePenalty: isPercentagePenalty ? 1 : 0,
			IsDaywisePenalty: isDayWisePenalty ? 1 : 0,
			DayPenalty: dayPenalty,
			goldProductFixedInterest: fixedInterestPercentage,
			IsAdjustInterestBasedOnDiffDays: isAdjustInterestBasedOnDiffDays ? 1 : 0,
			IsAdjustToUpperRoundOffValue: isRoundOffToUpperValue ? 1 : 0,
			IsProcessingFeeAutoDetect: isProcessingFeeAutoDetect ? 1 : 0,
			EffectiveDate: effectiveDate,
			InActiveDate: inActiveDate,
			IsPreCloseCharge: isPreCloseCharge ? 1 : 0,
			preClosePercentage: preCloseChargePercentage,
			NeedDifferentialPayout: needDifferentialPayout ? 1 : 0,
			IsCollectInterestOnDisbusement: isCollectInterestOnDisbusement ? 1 : 0,
			IncludeSaturday: isIncludeSaturday ? 1 : 0,
			IncludeSunday: isIncludeSunday ? 1 : 0,
			InstalmentType: productInstallmentType,
			IsCorporateProduct: isCorporateProduct ? 1 : 0,
			PercentageOnSellingPrice: percentageOnSellingPrice,
			GoldMinimumInterestDays: minimumInterestDays,
			ordinaryDate: ordinaryDays,
			ordinaryAmount: ordinaryAmount,
			registerDate: registerDays,
			registerAmount: registerAmount,
			auctionDate: auctionDays,
			auctionAmount: auctionAmount,
			ProductDescription: productDescription,
			MemberAmount: memberAmount,
			ProductPrincipal: interestAmount,
			ProductInterest: interestPercentage,
			NoOfYears: noOfYear,
			InstallmentMethod: installmentMethod,
			InstallmentReturnType: productInterestType,
			HolidayType: holidayType,
			ProductCreatedBy: userID,
			UniqueProductID: uniqueProductID,
			DocumentCharges: docCharges,
			ProcessingFees: processingFee,
			ProcessingFeesPercentage: processingFeePercentage,
			CGST: cgst,
			CGSTPercentage: cgstPercentage,
			IGST: igst,
			IGSTPercentage: igstPercentage,
			SGST: sgst,
			SGSTPercentage: sgstPercentage,
			ProductType: productType,
			IsPenalty: isPenalty ? 1 : 0,
			PenaltyPercentage: penaltyPercentage,
			verificationFee: verificationFee,
			HPFee: hpFee,
			InsurenseFee: insuranceFee,
			InsurenseFeePercentage: insuranceFeePercentage,
			Noofstartday: noOfDaysToStartDisbursement,
			IsFirstWeekMonthly: isFirstWeekMonthly ? 1 : 0,
			IsInstalmentBasedCollection: isInstallmentBasedCollection ? 1 : 0,
			AssetType: assetType,
			NoofDueInterval: noOfDueInterval,
			IsSameDueDate: isSameDateAsDue ? 1 : 0,
			IsInterestBasedOnStartDate: intersetBasedOnStartDate ? 1 : 0,
			IsFixedEMI: isFixedEMI ? 1 : 0,
			FixedEMIAmount: fixedEMIAmount,
			goldProductInterestArr: getGoldInterestListJson,
			interestType: variedInterest && getGoldInterestListArr.length > 0 ? 1 : 0,
			PrincipalAmountLedger: principalAmountLedger,
			InterestAmountLedger: interestAmountLedger,
			LoanAmountLedger: loanAmountLedger,
			PenaltyAmountLedger: penaltyAmountLedger,
			BMAdvanceAmountLedger: bmAdvanceAmountLedger,
			WriteOffLedger: writeOfftAmountLedger,
			InterestWriteOffLedger: interestWriteOffAmountLedger,
			InterestAccuralLedger: interestAccuralLedger,
			DisbursementType: disbursementType,
			ChequeToBeCollected: chequeToBeCollected,
			InsuranceProductLedger: insuranceProductLedger,
			NoOfCheque: noOfCheque,
			Membersettlement: memberSettlement,
			MemberAmountLedger: memberAmountLedger,
			DocumentChargesLedger: documentChargesLedger,
			ProcessingFeeLedger: processingFeeLedger,
			IGSTAmountLedger: igstAmountLedger,
			CGSTAmountLedger: cgstAmountLedger,
			SGSTAmountLedger: sgstAmountLedger,
			VerificationFeeLedger: verificationFeeLedger,
			HPInsuranceProductLedger: hpInsuranceProductLedger,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
			LoanDataforDiminishing: loanschedulelistJson,
			ProductTypeLoan: productTypeLoan,
			FixedInterestPercentage: fixedInterestPercentage,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(productDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateProductDetailsFailure(responseData.data));
		} else {
			yield put(updateProductDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateProductDetailsFailure(error));
	}
}

export function* resetUpdateProductDetailsResponse() {
	yield put(updateProductDetailsResponseChanged());
}

export function* onUpdateProductDetails() {
	yield takeLatest(productActionTypes.UPDATE_PRODUCT_DETAILS_START, productUpdate);
}

export function* onUpdateProductResponseReset() {
	yield takeLatest(
		productActionTypes.UPDATE_PRODUCT_DETAILS_RESPONSE_RESET,
		resetUpdateProductDetailsResponse,
	);
}
/** *********************  END UPDATE PRODUCT DETAILS ******************** */

/** *********************  START GET PRODUCT LIST  ******************** */
export function* productDetailsListGet({ payload }: any) {
	try {
		const key = 'GetProductListKey';
		const jsonData = {
			CompanyID: payload.companyID,
			UserID: payload.userID,
			UserRole: payload.userRole,
			UserLevel: payload.userLevel,
			DatabaseName: payload.databaseName,
			SearchData: payload.inputSearch,
			Limit: payload.limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(productListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getProductListFailure(responseData.data));
		} else {
			yield put(getProductListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getProductListFailure(error));
	}
}

export function* resetGetProductListResponse() {
	yield put(getProductListResponseChanged());
}

export function* onGetProductListDetails() {
	yield takeLatest(productActionTypes.GET_PRODUCT_LIST_START, productDetailsListGet);
}

export function* onGetProductListResponseReset() {
	yield takeLatest(
		productActionTypes.GET_PRODUCT_LIST_RESPONSE_RESET,
		resetGetProductListResponse,
	);
}
/** *********************  END GET PRODUCT LIST ******************** */

/** *********************  START FETCH PRODUCT DETAILS  ******************** */
export function* fetchProductData({ payload }: any) {
	try {
		const key = 'FetchProductDetailsKey';
		const jsonData = {
			CompanyID: payload.companyID,
			ProductID: payload.productID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(productDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchProductDetailsFailure(responseData.data));
		} else {
			yield put(fetchProductDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchProductDetailsFailure(error));
	}
}

export function* resetFetchProductDetailsResponse() {
	yield put(fetchProductDetailsResponseChanged());
}

export function* onFetchProductDetails() {
	yield takeLatest(productActionTypes.FETCH_PRODUCT_DETAILS_START, fetchProductData);
}

export function* onFetchProductResponseReset() {
	yield takeLatest(
		productActionTypes.FETCH_PRODUCT_DETAILS_RESPONSE_RESET,
		resetFetchProductDetailsResponse,
	);
}
/** *********************  END FETCH PRODUCT DETAILS  ******************** */

/** *********************  START FETCH CUSTOM PRODUCT DETAILS  ******************** */
export function* fetchCustomProductData({ payload }: any) {
	try {
		const key = 'GetCustomProductListKey';
		const { productID } = payload;
		const jsonData = {
			CompanyID: payload.companyID,
			ProductID: productID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(customProductDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchCustomProductDetailsFailure(responseData.data));
		} else {
			yield put(fetchCustomProductDetailsSuccess(responseData.data, productID));
		}
	} catch (error) {
		yield put(fetchCustomProductDetailsFailure(error));
	}
}

export function* resetFetchCustomProductDetailsResponse() {
	yield put(fetchCustomProductDetailsResponseChanged());
}

export function* onFetchCustomProductDetails() {
	yield takeEvery(productActionTypes.FETCH_CUSTOM_PRODUCT_DETAILS_START, fetchCustomProductData);
}

export function* onFetchCustomProductResponseReset() {
	yield takeLatest(
		productActionTypes.FETCH_CUSTOM_PRODUCT_DETAILS_RESPONSE_RESET,
		resetFetchCustomProductDetailsResponse,
	);
}
/** *********************  END FETCH CUSTOM PRODUCT DETAILS  ******************** */

/** *********************  START DELETE PRODUCT DETAILS  ******************** */
export function* productDelete({ payload }: any) {
	try {
		const key = 'DeleteProductDetailsKey';
		const jsonData = {
			CompanyID: payload.companyID,
			ProductID: payload.productID,
			IsView: payload.isView,
			ProductName: payload.productName,
			DatabaseName: payload.databaseName,
			ProductCreatedBy: payload.userID,
			UserAccessBranchID: payload.userAccessBranchID,
			UserName: payload.userName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(productDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteProductDetailsFailure(responseData.data));
		} else {
			yield put(deleteProductDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteProductDetailsFailure(error));
	}
}

export function* resetDeleteProductDetailsResponse() {
	yield put(deleteProductDetailsResponseChanged());
}

export function* onDeleteProductDetail() {
	yield takeLatest(productActionTypes.DELETE_PRODUCT_DETAILS_START, productDelete);
}

export function* onDeleteProductResponseReset() {
	yield takeLatest(
		productActionTypes.DELETE_PRODUCT_DETAILS_RESPONSE_RESET,
		resetDeleteProductDetailsResponse,
	);
}
/** *********************  END DELETE PRODUCT DETAILS ******************** */

/** ***************** GET MATSER ACCOUNT LIST START *********************** */
export function* masterAccountListGet({ payload }: any) {
	try {
		const key = 'GetMasterAccountListKey';
		const jsonData = {
			InfogCompanyID: payload.infogCompanyID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getMasterAccountList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMasterAccountListFailure(responseData.data));
		} else {
			yield put(getMasterAccountListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMasterAccountListFailure(error));
	}
}

export function* resetGetMasterAccountListResponse() {
	yield put(getMasterAccountListResponseChanged());
}

export function* onGetMasterAccountListDetails() {
	yield takeLatest(productActionTypes.GET_MASTER_ACCOUNT_LIST_START, masterAccountListGet);
}

export function* onGetMasterAccountListResponseReset() {
	yield takeLatest(
		productActionTypes.GET_MASTER_ACCOUNT_LIST_RESPONSE_RESET,
		resetGetMasterAccountListResponse,
	);
}
/** ***************** GET MATSER ACCOUNT LIST END *********************** */

/** *********************  START GET ALL INSTRUMENT LIST  ******************** */
export function* allInstrumentListGet({ payload }: any) {
	try {
		const key = 'GetAllInstrumentListKey';
		const jsonData = {
			InfogCompanyID: payload.infogCompanyID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllInstrumentList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAllInstrumnetListFailure(responseData.data));
		} else {
			yield put(getAllInstrumnetListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAllInstrumnetListFailure(error));
	}
}

export function* resetGetAllInstrumentListResponse() {
	yield put(getAllInstrumnetListResponseChanged());
}

export function* onGetAllInstrumnetListDetails() {
	yield takeLatest(productActionTypes.GET_ALL_INSTRUMENT_LIST_START, allInstrumentListGet);
}

export function* onGetAllInstrumnetListResponseReset() {
	yield takeLatest(
		productActionTypes.GET_ALL_INSTRUMENT_LIST_RESPONSE_RESET,
		resetGetAllInstrumentListResponse,
	);
}
/** *********************  END GET ALL INSTRUMENT LIST ******************** */

/** *********************  START FETCH FILTER PRODUCT LIST  ******************** */
export function* fetchFilterProductListGet({ payload }: any) {
	try {
		const key = 'GetFilterProductListKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			ProductType: payload.productType,
			IsAutoLoanType: payload.isAutoLoanType,
			IsRange: payload.isRange,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(filterProductListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchFilterProductListFailure(responseData.data));
		} else {
			yield put(fetchFilterProductListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchFilterProductListFailure(error));
	}
}

export function* resetFetchFilterProductListResponse() {
	yield put(fetchFilterProductListResponseChanged());
}

export function* onFetchFilterProductListDetails() {
	yield takeLatest(productActionTypes.FETCH_FILTER_PRODUCT_LIST_START, fetchFilterProductListGet);
}

export function* onFetchFilterProductListResponseReset() {
	yield takeLatest(
		productActionTypes.FETCH_FILTER_PRODUCT_LIST_RESPONSE_RESET,
		resetFetchFilterProductListResponse,
	);
}
/** *********************  END FETCH FILTER PRODUCT LIST ******************** */

/** *********************  GET PRODUCT DETAILS LIST START ******************** */
export function* productListDetailsGet({ payload }: any) {
	try {
		const key = 'getProductDetailsKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			ProductID: payload.ProductID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(productDetailsListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getProductDetailsListFailure(responseData.data));
		} else {
			yield put(getProductDetailsListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getProductDetailsListFailure(error));
	}
}

export function* resetGetProductDetailsListResponse() {
	yield put(getProductDetailsListResponseChanged());
}

export function* onGetProductDetailsListDetails() {
	yield takeLatest(productActionTypes.GET_PRODUCT_DETAILS_LIST_START, productListDetailsGet);
}

export function* onGetProductDetailsListResponseReset() {
	yield takeLatest(
		productActionTypes.GET_PRODUCT_DETAILS_LIST_RESPONSE_RESET,
		resetGetProductDetailsListResponse,
	);
}
/** *********************  GET PRODUCT DETAILS LIST END ******************** */

export function* productMasterSaga() {
	yield all([
		call(onCreateProductDetails),
		call(onCreateProductResponseReset),
		call(onUpdateProductDetails),
		call(onUpdateProductResponseReset),
		call(onGetProductListDetails),
		call(onGetProductListResponseReset),
		call(onFetchProductDetails),
		call(onFetchProductResponseReset),
		call(onFetchCustomProductDetails),
		call(onFetchCustomProductResponseReset),
		call(onDeleteProductDetail),
		call(onDeleteProductResponseReset),
		call(onGetMasterAccountListDetails),
		call(onGetMasterAccountListResponseReset),
		call(onGetAllInstrumnetListDetails),
		call(onGetAllInstrumnetListResponseReset),
		call(onFetchFilterProductListDetails),
		call(onFetchFilterProductListResponseReset),
		call(onGetProductDetailsListDetails),
		call(onGetProductDetailsListResponseReset),
	]);
}
